import React from 'react'
import { CFView } from 'components'

export default ({ children, title, LeftButton, ...props }) => {
  return (
    <CFView
      br="5px"
      bg="rgba(255,255,255,.7)"
      boxShadow="1px 1px 3px rgba(0,0,0,.8)"
      overflow="hidden"
      relative
      {...props}
    >
      <CFView absolute top="22px" left="40px">
        {LeftButton}
      </CFView>
      {title && (
        <CFView h2 bold textCenter mb="20px">
          {title}
        </CFView>
      )}
      {children}
    </CFView>
  )
}
